<p [class]="getDescClasses()" [innerHTML]="text | translate"></p>
